module.exports = __webpack_public_path__ + "static/img/rightPop.1d230bc2.png";